import styled from 'styled-components';

export const DirectoryContainer = styled.div`
    width: 100%;
    height: calc(100vh - 112px - 134px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 22.5px;
`;